var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sInputNumber',_vm._b({attrs:{"clearable":"","data-qa":_vm.dataQa,"minus":true,"output-type":"String","precision":_vm.criteria.props.allowDecimals ? 5 : 0,"use-thousand-separator":true,"value":_vm.valueMutable},on:{"update:value":function($event){_vm.valueMutable=$event}}},'sInputNumber',_vm.numberOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }